import { useEffect } from "react";
import { TextInput } from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";

const CalculationResult = ({ dependOn, ...props }) => {
  const [debt, correction, arDebitValue] = useWatch({ name: dependOn });
  const { setValue } = useFormContext();
  useEffect(() => {
    let firstEntity = 0;
    let secondEntity = 0;
    if (debt !== undefined && debt !== "") {
      firstEntity = +debt;
    }
    if (correction !== undefined && correction !== "") {
      secondEntity = +correction;
    }
    if (arDebitValue) {
      setValue("calculation_result", firstEntity + secondEntity);
    } else {
      setValue("calculation_result", firstEntity - secondEntity);
    }
  }, [debt, correction, arDebitValue]);
  return <TextInput {...props} source="calculation_result" disabled />;
};

export default CalculationResult;
